import React, { useEffect, useRef } from 'react';
import { AnimatePresence, motion, Variants } from 'framer-motion';

const fill: React.CSSProperties = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  minHeight: 0,
};

// Item 4: direction-aware fade + rise. Forward enters from below / exits up;
// going back enters from above / exits down.
const riseVariants: Variants = {
  enter: (d: number) => ({ y: d >= 0 ? 30 : -30, opacity: 0 }),
  center: { y: 0, opacity: 1 },
  exit: (d: number) => ({ y: d >= 0 ? -22 : 22, opacity: 0 }),
};

const ContentTransition: React.FC<{
  step: number;
  children: React.ReactNode;
}> = ({ step, children }) => {
  const prevRef = useRef(step);
  const direction = step >= prevRef.current ? 1 : -1;
  useEffect(() => {
    prevRef.current = step;
  }, [step]);

  return (
    <AnimatePresence mode="wait" custom={direction} initial={false}>
      <motion.div
        key={step}
        custom={direction}
        variants={riseVariants}
        initial="enter"
        animate="center"
        exit="exit"
        transition={{ duration: 0.34, ease: [0.22, 0.61, 0.36, 1] }}
        style={fill}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};

export default ContentTransition;
